if (!customElements.get('product-set-form')) {
  customElements.define(
    'product-set-form',
    class ProductSetForm extends HTMLElement {
      constructor() {
        super();
        this.onFormData = this.onFormData.bind(this);
      }

      connectedCallback() {
        this.form = this.querySelector('form');
        const scope = this.closest('product-info') || this;
        if (!this.form || !scope.querySelector('[data-product-set-selection]')) return;

        this.form.addEventListener('formdata', this.onFormData);
        this.hidden = false;
      }

      disconnectedCallback() {
        this.form?.removeEventListener('formdata', this.onFormData);
      }

      onFormData(event) {
        this.rewriteFormData(event.formData);
      }

      rewriteFormData(formData) {
        const quantity = this.normalizeQuantity(formData.get('quantity'));
        const scope = this.closest('product-info') || this;
        const items = new Map();

        scope.querySelectorAll('[data-product-set-selection]').forEach((select) => {
          this.addQuantity(items, String(select.value || ''), quantity);
        });

        formData.delete('id');
        formData.delete('quantity');
        if (items.size === 0) return;

        scope.querySelectorAll('[data-product-set-gift]').forEach((gift) => {
          const giftQuantity = this.normalizeQuantity(gift.dataset.quantity) * quantity;
          this.addQuantity(items, String(gift.dataset.variantId || ''), giftQuantity);
        });

        let itemIndex = 0;
        items.forEach((itemQuantity, variantId) => {
          const prefix = `items[${itemIndex++}]`;
          formData.append(`${prefix}[id]`, variantId);
          formData.append(`${prefix}[quantity]`, String(itemQuantity));
        });
      }

      normalizeQuantity(value) {
        const quantity = Number.parseInt(value, 10);
        return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
      }

      addQuantity(items, variantId, quantity) {
        if (!/^\d+$/.test(variantId)) return;
        items.set(variantId, (items.get(variantId) || 0) + quantity);
      }
    },
  );
}
